import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { motion } from "framer-motion";
import * as Yup from "yup";

const axios = require("axios").default;

const LoginSchema = Yup.object().shape({
  username: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
});

function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  return (
    <div className="flex flex-col">
      <div className="flex justify-center">
        <button
          onClick={() => {
            navigate("/login");
          }}
          className="text-3xl text-center font-semibold py-7 text-stone-700"
        >
          flashcards
        </button>
      </div>
      <motion.div
        className="flex border border-slate-300 w-full px-24 border-t-0 border-b-0 sm:flex-col sm:px-10 xsm:px-5 md:flex-col-reverse md:mb-10 md:px-10 lg:px-5"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div
          id="left"
          className="border-t border-l border-b border-slate-300 w-6/12 rounded-sm rounded-r-none p-5 px-20 sm:w-full sm:border-r xsm:px-10 xxsm:px-5 md:border-r md:w-full lg:px-10"
        >
          <h2 className="text-2xl font-semibold mb-2 text-stone-700">Login</h2>

          <Formik
            initialValues={{
              username: "",
              password: "",
            }}
            validationSchema={LoginSchema}
            onSubmit={(values) => {
              axios
                .post(
                  "https://application-flashcards.herokuapp.com/api/users/login",
                  {
                    ...values,
                  }
                )
                .then(function (response) {
                  if (response.data === "Invalid Credentials") {
                    setError("Invalid Credentials");
                  } else {
                    const token = response.data.token;

                    localStorage.setItem("token", token);
                    navigate("/dashboard");
                  }
                })
                .catch(function (error) {
                  const serverError = error.response.data.message;
                  setError(serverError);
                });
            }}
          >
            {({ errors, touched }) => (
              <Form className="flex flex-col h-full ">
                <div className="flex flex-col mb-3">
                  <div className="flex justify-between">
                    <label for="username" className="my-2">
                      Username:
                    </label>
                    {errors.username && touched.username ? (
                      <p className="pt-2 text-md font-thin text-red-500">
                        {errors.username}
                      </p>
                    ) : null}
                  </div>
                  <Field
                    id="username"
                    placeholder=" Enter Username Here"
                    type="text"
                    name="username"
                    className="border border-slate-400 py-1"
                  />
                </div>
                <div className="flex flex-col mb-3">
                  <div className="flex justify-between">
                    <label for="password" className="my-2">
                      Password:
                    </label>
                    {errors.password && touched.password ? (
                      <p className="pt-2 text-md font-thin text-red-500">
                        {errors.password}
                      </p>
                    ) : null}
                  </div>
                  <Field
                    id="password"
                    placeholder=" Enter Password Here"
                    name="password"
                    type="password"
                    className="border border-slate-400 py-1"
                  />
                </div>
                {error ? (
                  <p className="text-red-500 font-light text-center">
                    Server Error: {error}
                  </p>
                ) : null}
                <button
                  className="bg-gradient-to-r from-red-400 to-blue-400 rounded-sm text-white text-xl py-2 mt-4 hover:font-semibold"
                  type="submit"
                >
                  Submit
                </button>
                <div className="flex justify-center my-4">
                  <div
                    onClick={() => {
                      navigate("/forgotpassword");
                    }}
                    className="text-lg text-gray-600 text-center cursor-pointer"
                  >
                    Forgot Password?
                  </div>
                </div>
                <div className="flex items-center justify-center mt-28 pb-4">
                  <p className="text-lg text-stone-700 whitespace-nowrap xxsm:text-base">
                    Don't have an account?
                  </p>
                  <div
                    onClick={() => {
                      navigate("/register");
                    }}
                    className="text-lg border border-2 border-blue-200 px-6 py-1 mx-4 font-small rounded-sm text-blue-500 hover:border-blue-300 hover:text-blue-600 cursor-pointer"
                  >
                    Register
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>

        <div
          id="right"
          className="border border-slate-300 w-6/12 rounded-sm rounded-l-none bg-gradient-to-r from-red-400 to-blue-400 pt-32 sm:hidden md:w-full md:pb-32 md:mb-4"
        >
          <p className="text-4xl font-light text-center text-white my-2">
            flashcards
          </p>
          <hr className="w-4/12 mx-auto" />
          <p className="text-xl font-thin text-center text-white my-1 mx-32 md:mx-20 lg:mx-10 2xl:mx-5">
            Virtual flashcards for when you don't have any.{" "}
            <span className="font-semibold">flashcards</span> helps you study
            the same way having flashcards would, except it's all virtual.
            Create as many flashcards as you need for as many tests that are
            coming up.
          </p>
        </div>
      </motion.div>
    </div>
  );
}

export default Login;
